export default __webpack_public_path__ + "static/media/based-chastity-logo.f91b3c99.png";